import { Navigate } from "react-router-dom";


const UnAuthRoute = ({ children, isAuthenticated }) => {

    if (isAuthenticated) {
        return <Navigate to="../profile" replace />;
    }

    return children;
}

export default UnAuthRoute;
